angular.module('blc').controller('filter_popup', filter_popup_ctrl);
filter_popup_ctrl.$inject = ['$scope', 'search', 'quote'];
function filter_popup_ctrl($scope, search, quote) {
  $scope.check_passenger = [999,999,999,999];
  $scope.check_bag = [];
  $scope.search = search;

  $scope.update_search = function () {
    search.check_passenger = $scope.check_passenger;
  }
  $scope.update_search();
  $scope.$watch(function() { return $scope.check_passenger.join(); }, $scope.update_search)
}




/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/filter_popup_ctrl.js
 ** module id = 24
 ** module chunks = 0
 **/